import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../../assets/styles/onlineyogacourse/onlineyogayttc.module.css";
import logo1 from "../../assets/images/brands/RPYS.webp";
import logo2 from "../../assets/images/brands/200.webp";
import logo3 from "../../assets/images/brands/300.webp";
import logo4 from "../../assets/images/brands/500.webp";
import { useNavigate } from "react-router-dom";
import BooksSection from "components/MyBooks/Bookssection";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API = `${API_BASE}/api/online-yoga-ttc`;

const DEFAULT_CONTENT = {
  heroWelcomeText: "Welcome to Hatha Yogashram",
  heroTitleLine1: "Your Gateway to",
  heroTitleLine2: "Ancient Wisdom",
  heroSubtitle:
    "Our Online Yoga Teacher Training Course (TTC) brings the transformative essence of traditional Hatha Yog directly to you, no matter where you are in the world.",
  heroImage: "",
  heroButtonText: "Begin Your Journey",
  heroButtonLink: "/BookingForm",
  aboutSectionLabel: "Our Offerings",
  aboutSectionTitle: "About Our Courses",
  courses: [
    {
      id: 1,
      title: "200 Hour TTC",
      duration: "24 Days",
      certification: "Yoga Alliance USA",
      style: "Multi-Style",
      date: "2nd of every month",
      image: "https://images.unsplash.com/photo-1588286840104-8957b019727f?w=600",
      oldPrice: "$399.00",
      newPrice: "$199.00",
      isNew: true,
    },
    {
      id: 2,
      title: "300 Hour TTC",
      duration: "28 Days",
      certification: "Yoga Alliance USA",
      style: "Multi-Style",
      date: "2nd of every month",
      image: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=600",
      oldPrice: "$599.00",
      newPrice: "$399.00",
      isNew: true,
    },
    {
      id: 3,
      title: "500 Hour TTC",
      duration: "56 Days",
      certification: "Yoga Alliance USA",
      style: "Multi-Style",
      date: "2nd of every month",
      image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600",
      oldPrice: "$998.00",
      newPrice: "$498.00",
      isNew: true,
    },
  ],
  bookingSectionLabel: "Reserve Your Spot",
  bookingSectionTitle: "Booking Courses Now",
  bookingSectionDescription:
    "At Hatha Yogashram, we believe yoga is more than just a practice. Nestled in the serene foothills of the Himalayas, our ashram has been a sanctuary for seekers for years.",
  bookingCourses: [],
  testimonialsSectionLabel: "Student Experiences",
  testimonialsSectionTitle: "What Students are Saying",
  testimonials: [
    {
      name: "Olya Beitelman",
      time: "a year ago",
      text: "A recommended place for yoga, a good atmosphere and a teacher who pays attention, explains and corrects",
      rating: 5,
    },
    {
      name: "Lucy Ashley",
      time: "a year ago",
      text: "I went for a drop Hatha class and really enjoyed it. I've practised yoga for a while but I'm kind of new to Hatha.",
      rating: 5,
    },
    {
      name: "Harish Rabecka",
      time: "a year ago",
      text: "I have completed yoga and now I have shared my inspiration with you because my teacher taught me that you will not be alone on the path.",
      rating: 5,
    },
  ],
  whyUsSectionLabel: "Our Promise",
  whyUsSectionTitle: "Why Choose Us",
  whyUsIntro:
    "At Hatha Yogashram, we believe yoga is more than just a practice. Nestled in the serene foothills of the Himalayas, our ashram has been a sanctuary for seekers for years.",
  whyUsImage: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=800",
  whyUsBenefits: [
    {
      title: "Authentic Teachings",
      description:
        "Learn traditional Hatha Yog from experienced instructors rooted in the lineage of Rishikesh, the Yoga Capital of the World.",
    },
    {
      title: "Flexible Learning",
      description:
        "Study at your own pace with pre-recorded sessions, live classes, and interactive Q&A opportunities.",
    },
    {
      title: "Global Recognition",
      description:
        "Earn a Yoga Alliance-approved certificate upon completion, empowering you to teach yoga worldwide.",
    },
    {
      title: "Comprehensive Curriculum",
      description:
        "Master asanas, pranayama, meditation, anatomy, philosophy, and teaching methodology.",
    },
  ],
  certificationLogos: [
    { id: 1, image: logo1, alt: "Yoga Alliance" },
    { id: 2, image: logo2, alt: "RYS 200" },
    { id: 3, image: logo3, alt: "RYS 300" },
    { id: 4, image: logo4, alt: "RYS 500" },
  ],
  certificationParagraph1:
    "At Hatha Yogashram, our core focus lies in the practice of traditional Hatha Yog. We enrich training with anatomy, alignment, pranayama, philosophy, meditation, Ayurveda, and mantra chanting.",
  certificationParagraph2:
    "Our main instructors are internationally certified and inspire students to reach their fullest potential with personalized attention in small group settings.",
  certificationHighlight: "best yoga teacher training in India",
  howItWorksLabel: "Simple Process",
  howItWorksTitle: "How It Works",
  steps: [
    {
      step: "01",
      title: "Enroll Online",
      description:
        "Choose your preferred course and complete the simple registration process.",
    },
    {
      step: "02",
      title: "Access Materials",
      description:
        "Gain instant access to our user-friendly online platform with videos, manuals, and resources.",
    },
    {
      step: "03",
      title: "Learn & Practice",
      description:
        "Follow the structured curriculum at your pace, with the option to join live sessions.",
    },
    {
      step: "04",
      title: "Get Certified",
      description:
        "Complete assignments, quizzes, and a final teaching demonstration to earn your certification.",
    },
  ],
  finalCtaTitle: "Ready to Begin?",
  finalCtaText:
    "Enroll now and take the first step toward becoming a certified yoga teacher with Hatha Yogashram!",
  finalCtaButtonText: "Contact Us Today",
  finalCtaButtonLink: "/contact-us",
};

const resolveImageSrc = (image) => {
  if (!image) return "";
  if (/^https?:\/\//.test(image)) return image;
  if (image.startsWith("/uploads/")) return `${API_BASE}${image}`;
  return `${API_BASE}/uploads/${image}`;
};

const mergeContent = (incoming) => ({
  ...DEFAULT_CONTENT,
  ...incoming,
  courses:
    Array.isArray(incoming?.courses) && incoming.courses.length
      ? incoming.courses
      : DEFAULT_CONTENT.courses,
  bookingCourses:
    Array.isArray(incoming?.bookingCourses) && incoming.bookingCourses.length
      ? incoming.bookingCourses
      : DEFAULT_CONTENT.courses,
  testimonials:
    Array.isArray(incoming?.testimonials) && incoming.testimonials.length
      ? incoming.testimonials
      : DEFAULT_CONTENT.testimonials,
  whyUsBenefits:
    Array.isArray(incoming?.whyUsBenefits) && incoming.whyUsBenefits.length
      ? incoming.whyUsBenefits
      : DEFAULT_CONTENT.whyUsBenefits,
  certificationLogos:
    Array.isArray(incoming?.certificationLogos) && incoming.certificationLogos.length
      ? incoming.certificationLogos
      : DEFAULT_CONTENT.certificationLogos,
  steps:
    Array.isArray(incoming?.steps) && incoming.steps.length
      ? incoming.steps
      : DEFAULT_CONTENT.steps,
});

const OnlineYTTC = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(API);
        const latest = Array.isArray(res.data?.data) ? res.data.data[0] : null;

        if (latest) {
          setContent(mergeContent(latest));
        }
      } catch (error) {
        console.error("Online YTTC fetch error:", error.response?.data || error.message);
      }
    };

    fetchContent();
  }, []);

  const navigateTo = (link) => {
    if (!link) return;
    if (/^https?:\/\//.test(link)) {
      window.location.href = link;
      return;
    }
    navigate(link);
  };

  const testimonials = content.testimonials.map((item) => ({
    ...item,
    initial: item?.name?.trim()?.charAt(0)?.toUpperCase() || "Y",
    rating: Number(item?.rating || 5),
  }));

  const certificationLogos = content.certificationLogos.map((logo, index) => ({
    ...logo,
    id: logo?.id || index + 1,
    alt: logo?.alt || `Certification ${index + 1}`,
    image: resolveImageSrc(logo?.image),
  }));

  return (
    <div className={styles.container}>
      <svg
        className={styles.omDecor1}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 20 Q130 40 140 70 Q150 100 140 130 Q130 160 100 180 Q70 160 60 130 Q50 100 60 70 Q70 40 100 20 M80 60 Q90 70 100 70 Q110 70 120 60 M85 90 Q92 100 100 105 Q108 100 115 90 M75 120 Q85 135 100 140 Q115 135 125 120"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
      </svg>

      <section className={styles.hero}>
        <div className={styles.heroBackground}>
          <img
            src={resolveImageSrc(content.heroImage)}
            alt={content.heroTitleLine1}
            className={styles.heroImage}
          />
          <div className={styles.heroOverlay}></div>
        </div>

        <div className={styles.heroContent}>
          <div className={styles.omSymbol}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M50 10 Q65 20 70 35 Q75 50 70 65 Q65 80 50 90 Q35 80 30 65 Q25 50 30 35 Q35 20 50 10 M40 30 Q45 35 50 35 Q55 35 60 30 M42.5 45 Q46 50 50 52.5 Q54 50 57.5 45 M37.5 60 Q42.5 67.5 50 70 Q57.5 67.5 62.5 60"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              />
            </svg>
          </div>

          <p className={styles.welcomeText}>{content.heroWelcomeText}</p>
          <h1 className={styles.heroTitle}>
            {content.heroTitleLine1}
            <br />
            <span className={styles.highlight}>{content.heroTitleLine2}</span>
          </h1>
          <p className={styles.heroSubtitle}>{content.heroSubtitle}</p>
          <button
            className={styles.ctaButton}
            onClick={() => navigateTo(content.heroButtonLink)}
          >
            <span>{content.heroButtonText}</span>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <svg
          className={styles.swastikDecor}
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="currentColor" strokeWidth="4" fill="none">
            <line x1="50" y1="20" x2="50" y2="50" />
            <line x1="50" y1="50" x2="80" y2="50" />
            <line x1="80" y1="50" x2="80" y2="80" />
            <line x1="50" y1="50" x2="50" y2="80" />
            <line x1="50" y1="80" x2="20" y2="80" />
            <line x1="20" y1="80" x2="20" y2="50" />
            <line x1="20" y1="50" x2="50" y2="50" />
            <line x1="50" y1="50" x2="50" y2="20" />
          </g>
        </svg>
      </section>

      <section className={styles.coursesSection}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionLabel}>{content.aboutSectionLabel}</span>
          <h2 className={styles.sectionTitle}>{content.aboutSectionTitle}</h2>
          <div className={styles.titleUnderline}></div>
        </div>

        <div className={styles.coursesGrid}>
          {content.courses.map((course, index) => (
            <div key={course.id || index} className={styles.courseCard}>
              <div className={styles.courseImageWrapper}>
                <img
                  src={resolveImageSrc(course.image)}
                  alt={course.title}
                  className={styles.courseImage}
                />
                <div className={styles.courseOverlay}>
                  <svg
                    className={styles.courseOm}
                    viewBox="0 0 60 60"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 6 Q39 12 42 21 Q45 30 42 39 Q39 48 30 54 Q21 48 18 39 Q15 30 18 21 Q21 12 30 6 M24 18 Q27 21 30 21 Q33 21 36 18 M25.5 27 Q27.6 30 30 31.5 Q32.4 30 34.5 27 M22.5 36 Q25.5 40.5 30 42 Q34.5 40.5 37.5 36"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>
              </div>

              <div className={styles.courseContent}>
                <h3 className={styles.courseTitle}>{course.title}</h3>

                <div className={styles.courseDetails}>
                  <div className={styles.detailItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 6v6l4 2" />
                    </svg>
                    <span>Duration: {course.duration}</span>
                  </div>

                  <div className={styles.detailItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                      <path d="M6 12v5c3 3 9 3 12 0v-5" />
                    </svg>
                    <span>Certification: {course.certification}</span>
                  </div>

                  <div className={styles.detailItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                    <span>Style: {course.style}</span>
                  </div>

                  <div className={styles.detailItem}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <path d="M16 2v4M8 2v4M3 10h18" />
                    </svg>
                    <span>Date: {course.date}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.bookingSection}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionLabel}>{content.bookingSectionLabel}</span>
          <h2 className={styles.sectionTitle}>{content.bookingSectionTitle}</h2>
          <div className={styles.titleUnderline}></div>
          <p className={styles.sectionDescription}>{content.bookingSectionDescription}</p>
        </div>

        <div className={styles.bookingGrid}>
          {content.bookingCourses.map((course, index) => (
            <div key={course.id || index} className={styles.bookingCard}>
              {course.isNew && <span className={styles.newBadge}>NEW</span>}
              <div className={styles.bookingImageWrapper}>
                <img src={resolveImageSrc(course.image)} alt={course.title} />
              </div>
              <div className={styles.bookingContent}>
                <span className={styles.courseLabel}>Course</span>
                <h3 className={styles.bookingTitle}>{course.title}</h3>
                <div className={styles.priceContainer}>
                  <span className={styles.oldPrice}>{course.oldPrice}</span>
                  <span className={styles.newPrice}>{course.newPrice}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.testimonialsSection}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionLabel}>{content.testimonialsSectionLabel}</span>
          <h2 className={styles.sectionTitle}>{content.testimonialsSectionTitle}</h2>
          <div className={styles.titleUnderline}></div>
        </div>

        <div className={styles.testimonialsGrid}>
          {testimonials.map((testimonial, index) => (
            <div key={`${testimonial.name}-${index}`} className={styles.testimonialCard}>
              <div className={styles.quoteIcon}>"</div>
              <div className={styles.testimonialHeader}>
                {/* <div className={styles.avatar}>{testimonial.initial}</div> */}
                <div>
                  <h4 className={styles.reviewerName}>{testimonial.name}</h4>
                  <p className={styles.reviewTime}>{testimonial.time}</p>
                </div>
              </div>
              <div className={styles.stars}>
                {[...Array(testimonial.rating)].map((_, starIndex) => (
                  <svg key={starIndex} viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>
              <p className={styles.testimonialText}>{testimonial.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.whyUsSection}>
        <div className={styles.whyUsContent}>
          <span className={styles.sectionLabel}>{content.whyUsSectionLabel}</span>
          <h2 className={styles.sectionTitle}>{content.whyUsSectionTitle}</h2>
          <div className={styles.titleUnderline}></div>

          <p className={styles.whyUsIntro}>{content.whyUsIntro}</p>

          <div className={styles.benefitsList}>
            {content.whyUsBenefits.map((benefit, index) => (
              <div key={`${benefit.title}-${index}`} className={styles.benefitItem}>
                <svg
                  className={styles.benefitIcon}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <div>
                  <h4 className={styles.benefitTitle}>{benefit.title}</h4>
                  <p className={styles.benefitDescription}>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.whyUsImage}>
          <img src={resolveImageSrc(content.whyUsImage)} alt={content.whyUsSectionTitle} />
          <div className={styles.imageDecor}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.3" />
              <circle cx="50" cy="50" r="30" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5" />
              <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.7" />
            </svg>
          </div>
        </div>
      </section>

      <section className={styles.certificationSection}>
        <div className={styles.certLogos}>
          {certificationLogos.map((logo) => (
            <img key={logo.id} src={logo.image} alt={logo.alt} className={styles.certLogo} />
          ))}
        </div>

        <div className={styles.certContent}>
          <p className={styles.certText}>{content.certificationParagraph1}</p>
          <p className={styles.certText}>{content.certificationParagraph2}</p>
          {content.certificationHighlight && (
            <p className={styles.certText}>
              <strong>{content.certificationHighlight}</strong>
            </p>
          )}
        </div>

        <svg className={styles.lotusLeft} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.15" stroke="currentColor" strokeWidth="1.5" fill="none">
            <path d="M50 80 Q40 60 40 40 Q40 30 50 20" />
            <path d="M50 80 Q60 60 60 40 Q60 30 50 20" />
            <path d="M30 70 Q35 60 40 50" />
            <path d="M70 70 Q65 60 60 50" />
            <circle cx="50" cy="35" r="8" />
            <path d="M20 75 Q30 65 40 60" />
            <path d="M80 75 Q70 65 60 60" />
          </g>
        </svg>

        <svg className={styles.lotusRight} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.15" stroke="currentColor" strokeWidth="1.5" fill="none">
            <path d="M50 80 Q40 60 40 40 Q40 30 50 20" />
            <path d="M50 80 Q60 60 60 40 Q60 30 50 20" />
            <path d="M30 70 Q35 60 40 50" />
            <path d="M70 70 Q65 60 60 50" />
            <circle cx="50" cy="35" r="8" />
            <path d="M20 75 Q30 65 40 60" />
            <path d="M80 75 Q70 65 60 60" />
          </g>
        </svg>
      </section>

      <section className={styles.howItWorksSection}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionLabel}>{content.howItWorksLabel}</span>
          <h2 className={styles.sectionTitle}>{content.howItWorksTitle}</h2>
          <div className={styles.titleUnderline}></div>
        </div>

        <div className={styles.stepsContainer}>
          {content.steps.map((item, index) => (
            <div key={`${item.step}-${index}`} className={styles.stepCard}>
              <div className={styles.stepNumber}>{item.step}</div>
              <h3 className={styles.stepTitle}>{item.title}</h3>
              <p className={styles.stepDescription}>{item.description}</p>
              {index < content.steps.length - 1 && <div className={styles.stepConnector}></div>}
            </div>
          ))}
        </div>
      </section>

      <BooksSection />

      <section className={styles.finalCta}>
        <div className={styles.ctaContent}>
          <svg
            className={styles.ctaOm}
            viewBox="0 0 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M60 12 Q78 24 84 42 Q90 60 84 78 Q78 96 60 108 Q42 96 36 78 Q30 60 36 42 Q42 24 60 12 M48 36 Q54 42 60 42 Q66 42 72 36 M51 54 Q55.2 60 60 63 Q64.8 60 69 54 M45 72 Q51 81 60 84 Q69 81 75 72"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
            />
          </svg>

          <h2 className={styles.ctaTitle}>{content.finalCtaTitle}</h2>
          <p className={styles.ctaText}>{content.finalCtaText}</p>
          <button
            className={styles.ctaButton}
            onClick={() => navigateTo(content.finalCtaButtonLink)}
          >
            <span>{content.finalCtaButtonText}</span>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </section>

      <svg
        className={styles.omDecor2}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 20 Q130 40 140 70 Q150 100 140 130 Q130 160 100 180 Q70 160 60 130 Q50 100 60 70 Q70 40 100 20 M80 60 Q90 70 100 70 Q110 70 120 60 M85 90 Q92 100 100 105 Q108 100 115 90 M75 120 Q85 135 100 140 Q115 135 125 120"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          opacity="0.1"
        />
      </svg>
    </div>
  );
};

export default OnlineYTTC;
